// Typed client for the student inbox.
// Server: student-agent-api/routers/inbox_router.py mounted at /student/inbox

import api from './api';

export interface InboxItem {
  id: string;
  title: string;
  body: string;
  category: string;
  cta_url: string | null;
  cta_label: string | null;
  sent_at: string | null;
  read_at: string | null;
}

export interface InboxListResponse {
  items: InboxItem[];
  next_cursor: string | null;
  has_more: boolean;
}

export const inboxAPI = {
  list: async (opts: { cursor?: string; limit?: number; unreadOnly?: boolean } = {}): Promise<InboxListResponse> => {
    const params: Record<string, string | number | boolean> = {};
    if (opts.cursor) params.cursor = opts.cursor;
    if (opts.limit) params.limit = opts.limit;
    if (opts.unreadOnly) params.unread_only = true;
    const response = await api.get<InboxListResponse>('/student/inbox', { params });
    return response.data;
  },

  unreadCount: async (): Promise<number> => {
    const response = await api.get<{ unread: number }>('/student/inbox/unread-count');
    return response.data.unread || 0;
  },

  markRead: async (logId: string): Promise<void> => {
    await api.post(`/student/inbox/${logId}/read`);
  },

  markAllRead: async (): Promise<number> => {
    const response = await api.post<{ updated: number }>('/student/inbox/mark-all-read');
    return response.data.updated || 0;
  },

  dismiss: async (logId: string): Promise<void> => {
    await api.delete(`/student/inbox/${logId}`);
  },
};
